module.exports = __webpack_public_path__ + "static/seo-image-d4f5369747f189332f58d5d13c4a13ef.jpg";